import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private countries: any[] = [
    { id: 1, name: 'Afghanistan', code: 'AF', dialCode: '+93', flag: '🇦🇫' },
    { id: 2, name: 'Albania', code: 'AL', dialCode: '+355', flag: '🇦🇱' },
    { id: 3, name: 'Algeria', code: 'DZ', dialCode: '+213', flag: '🇩🇿' },
    { id: 4, name: 'Andorra', code: 'AD', dialCode: '+376', flag: '🇦🇩' },
    { id: 5, name: 'Angola', code: 'AO', dialCode: '+244', flag: '🇦🇴' },
    { id: 6, name: 'Argentina', code: 'AR', dialCode: '+54', flag: '🇦🇷' },
    { id: 7, name: 'Armenia', code: 'AM', dialCode: '+374', flag: '🇦🇲' },
    { id: 8, name: 'Australia', code: 'AU', dialCode: '+61', flag: '🇦🇺' },
    { id: 9, name: 'Austria', code: 'AT', dialCode: '+43', flag: '🇦🇹' },
    { id: 10, name: 'Azerbaijan', code: 'AZ', dialCode: '+994', flag: '🇦🇿' },
    { id: 11, name: 'Bahamas', code: 'BS', dialCode: '+1242', flag: '🇧🇸' },
    { id: 12, name: 'Bahrain', code: 'BH', dialCode: '+973', flag: '🇧🇭' },
    { id: 13, name: 'Bangladesh', code: 'BD', dialCode: '+880', flag: '🇧🇩' },
    { id: 14, name: 'Barbados', code: 'BB', dialCode: '+1246', flag: '🇧🇧' },
    { id: 15, name: 'Belarus', code: 'BY', dialCode: '+375', flag: '🇧🇾' },
    { id: 16, name: 'Belgium', code: 'BE', dialCode: '+32', flag: '🇧🇪' },
    { id: 17, name: 'Belize', code: 'BZ', dialCode: '+501', flag: '🇧🇿' },
    { id: 18, name: 'Benin', code: 'BJ', dialCode: '+229', flag: '🇧🇯' },
    { id: 19, name: 'Bhutan', code: 'BT', dialCode: '+975', flag: '🇧🇹' },
    { id: 20, name: 'Bolivia', code: 'BO', dialCode: '+591', flag: '🇧🇴' },
    {
      id: 21,
      name: 'Bosnia and Herzegovina',
      code: 'BA',
      dialCode: '+387',
      flag: '🇧🇦',
    },
    { id: 22, name: 'Botswana', code: 'BW', dialCode: '+267', flag: '🇧🇼' },
    { id: 23, name: 'Brazil', code: 'BR', dialCode: '+55', flag: '🇧🇷' },
    { id: 24, name: 'Brunei', code: 'BN', dialCode: '+673', flag: '🇧🇳' },
    { id: 25, name: 'Bulgaria', code: 'BG', dialCode: '+359', flag: '🇧🇬' },
    { id: 26, name: 'Burkina Faso', code: 'BF', dialCode: '+226', flag: '🇧🇫' },
    { id: 27, name: 'Burundi', code: 'BI', dialCode: '+257', flag: '🇧🇮' },
    { id: 28, name: 'Cambodia', code: 'KH', dialCode: '+855', flag: '🇰🇭' },
    { id: 29, name: 'Cameroon', code: 'CM', dialCode: '+237', flag: '🇨🇲' },
    { id: 30, name: 'Canada', code: 'CA', dialCode: '+1', flag: '🇨🇦' },
    { id: 31, name: 'Cape Verde', code: 'CV', dialCode: '+238', flag: '🇨🇻' },
    {
      id: 32,
      name: 'Central African Republic',
      code: 'CF',
      dialCode: '+236',
      flag: '🇨🇫',
    },
    { id: 33, name: 'Chad', code: 'TD', dialCode: '+235', flag: '🇹🇩' },
    { id: 34, name: 'Chile', code: 'CL', dialCode: '+56', flag: '🇨🇱' },
    { id: 35, name: 'China', code: 'CN', dialCode: '+86', flag: '🇨🇳' },
    { id: 36, name: 'Colombia', code: 'CO', dialCode: '+57', flag: '🇨🇴' },
    { id: 37, name: 'Comoros', code: 'KM', dialCode: '+269', flag: '🇰🇲' },
    { id: 38, name: 'Congo', code: 'CG', dialCode: '+242', flag: '🇨🇬' },
    { id: 39, name: 'Costa Rica', code: 'CR', dialCode: '+506', flag: '🇨🇷' },
    { id: 40, name: 'Croatia', code: 'HR', dialCode: '+385', flag: '🇭🇷' },
    { id: 41, name: 'Cuba', code: 'CU', dialCode: '+53', flag: '🇨🇺' },
    { id: 42, name: 'Cyprus', code: 'CY', dialCode: '+357', flag: '🇨🇾' },
    {
      id: 43,
      name: 'Czech Republic',
      code: 'CZ',
      dialCode: '+420',
      flag: '🇨🇿',
    },
    { id: 44, name: 'Denmark', code: 'DK', dialCode: '+45', flag: '🇩🇰' },
    { id: 45, name: 'Djibouti', code: 'DJ', dialCode: '+253', flag: '🇩🇯' },
    { id: 46, name: 'Dominica', code: 'DM', dialCode: '+1767', flag: '🇩🇲' },
    {
      id: 47,
      name: 'Dominican Republic',
      code: 'DO',
      dialCode: '+1',
      flag: '🇩🇴',
    },
    { id: 48, name: 'Ecuador', code: 'EC', dialCode: '+593', flag: '🇪🇨' },
    { id: 49, name: 'Egypt', code: 'EG', dialCode: '+20', flag: '🇪🇬' },
    { id: 50, name: 'El Salvador', code: 'SV', dialCode: '+503', flag: '🇸🇻' },
    {
      id: 51,
      name: 'Equatorial Guinea',
      code: 'GQ',
      dialCode: '+240',
      flag: '🇬🇶',
    },
    { id: 52, name: 'Eritrea', code: 'ER', dialCode: '+291', flag: '🇪🇷' },
    { id: 53, name: 'Estonia', code: 'EE', dialCode: '+372', flag: '🇪🇪' },
    { id: 54, name: 'Ethiopia', code: 'ET', dialCode: '+251', flag: '🇪🇹' },
    { id: 55, name: 'Fiji', code: 'FJ', dialCode: '+679', flag: '🇫🇯' },
    { id: 56, name: 'Finland', code: 'FI', dialCode: '+358', flag: '🇫🇮' },
    { id: 57, name: 'France', code: 'FR', dialCode: '+33', flag: '🇫🇷' },
    { id: 58, name: 'Gabon', code: 'GA', dialCode: '+241', flag: '🇬🇦' },
    { id: 59, name: 'Gambia', code: 'GM', dialCode: '+220', flag: '🇬🇲' },
    { id: 60, name: 'Georgia', code: 'GE', dialCode: '+995', flag: '🇬🇪' },
    { id: 61, name: 'Germany', code: 'DE', dialCode: '+49', flag: '🇩🇪' },
    { id: 62, name: 'Ghana', code: 'GH', dialCode: '+233', flag: '🇬🇭' },
    { id: 63, name: 'Greece', code: 'GR', dialCode: '+30', flag: '🇬🇷' },
    { id: 64, name: 'Grenada', code: 'GD', dialCode: '+1473', flag: '🇬🇩' },
    { id: 65, name: 'Guatemala', code: 'GT', dialCode: '+502', flag: '🇬🇹' },
    { id: 66, name: 'Guinea', code: 'GN', dialCode: '+224', flag: '🇬🇳' },
    { id: 67, name: 'Guinea-Bissau', code: 'GW', dialCode: '+245', flag: '🇬🇼' },
    { id: 68, name: 'Guyana', code: 'GY', dialCode: '+592', flag: '🇬🇾' },
    { id: 69, name: 'Haiti', code: 'HT', dialCode: '+509', flag: '🇭🇹' },
    { id: 70, name: 'Honduras', code: 'HN', dialCode: '+504', flag: '🇭🇳' },
    { id: 71, name: 'Hong Kong', code: 'HK', dialCode: '+852', flag: '🇭🇰' },
    { id: 72, name: 'Hungary', code: 'HU', dialCode: '+36', flag: '🇭🇺' },
    { id: 73, name: 'Iceland', code: 'IS', dialCode: '+354', flag: '🇮🇸' },
    { id: 74, name: 'India', code: 'IN', dialCode: '+91', flag: '🇮🇳' },
    { id: 75, name: 'Indonesia', code: 'ID', dialCode: '+62', flag: '🇮🇩' },
    { id: 76, name: 'Iran', code: 'IR', dialCode: '+98', flag: '🇮🇷' },
    { id: 77, name: 'Iraq', code: 'IQ', dialCode: '+964', flag: '🇮🇶' },
    { id: 78, name: 'Ireland', code: 'IE', dialCode: '+353', flag: '🇮🇪' },
    { id: 79, name: 'Israel', code: 'IL', dialCode: '+972', flag: '🇮🇱' },
    { id: 80, name: 'Italy', code: 'IT', dialCode: '+39', flag: '🇮🇹' },
    { id: 81, name: 'Jamaica', code: 'JM', dialCode: '+1876', flag: '🇯🇲' },
    { id: 82, name: 'Japan', code: 'JP', dialCode: '+81', flag: '🇯🇵' },
    { id: 83, name: 'Jordan', code: 'JO', dialCode: '+962', flag: '🇯🇴' },
    { id: 84, name: 'Kazakhstan', code: 'KZ', dialCode: '+7', flag: '🇰🇿' },
    { id: 85, name: 'Kenya', code: 'KE', dialCode: '+254', flag: '🇰🇪' },
    { id: 86, name: 'Kiribati', code: 'KI', dialCode: '+686', flag: '🇰🇮' },
    { id: 87, name: 'Kuwait', code: 'KW', dialCode: '+965', flag: '🇰🇼' },
    { id: 88, name: 'Kyrgyzstan', code: 'KG', dialCode: '+996', flag: '🇰🇬' },
    { id: 89, name: 'Laos', code: 'LA', dialCode: '+856', flag: '🇱🇦' },
    { id: 90, name: 'Latvia', code: 'LV', dialCode: '+371', flag: '🇱🇻' },
    { id: 91, name: 'Lebanon', code: 'LB', dialCode: '+961', flag: '🇱🇧' },
    { id: 92, name: 'Lesotho', code: 'LS', dialCode: '+266', flag: '🇱🇸' },
    { id: 93, name: 'Liberia', code: 'LR', dialCode: '+231', flag: '🇱🇷' },
    { id: 94, name: 'Libya', code: 'LY', dialCode: '+218', flag: '🇱🇾' },
    { id: 95, name: 'Liechtenstein', code: 'LI', dialCode: '+423', flag: '🇱🇮' },
    { id: 96, name: 'Lithuania', code: 'LT', dialCode: '+370', flag: '🇱🇹' },
    { id: 97, name: 'Luxembourg', code: 'LU', dialCode: '+352', flag: '🇱🇺' },
    { id: 98, name: 'Macau', code: 'MO', dialCode: '+853', flag: '🇲🇴' },
    { id: 99, name: 'Madagascar', code: 'MG', dialCode: '+261', flag: '🇲🇬' },
    { id: 100, name: 'Malawi', code: 'MW', dialCode: '+265', flag: '🇲🇼' },
    { id: 101, name: 'Malaysia', code: 'MY', dialCode: '+60', flag: '🇲🇾' },
    { id: 102, name: 'Maldives', code: 'MV', dialCode: '+960', flag: '🇲🇻' },
    { id: 103, name: 'Mali', code: 'ML', dialCode: '+223', flag: '🇲🇱' },
    { id: 104, name: 'Malta', code: 'MT', dialCode: '+356', flag: '🇲🇹' },
    {
      id: 105,
      name: 'Marshall Islands',
      code: 'MH',
      dialCode: '+692',
      flag: '🇲🇭',
    },
    { id: 106, name: 'Mauritania', code: 'MR', dialCode: '+222', flag: '🇲🇷' },
    { id: 107, name: 'Mauritius', code: 'MU', dialCode: '+230', flag: '🇲🇺' },
    { id: 108, name: 'Mexico', code: 'MX', dialCode: '+52', flag: '🇲🇽' },
    { id: 109, name: 'Micronesia', code: 'FM', dialCode: '+691', flag: '🇫🇲' },
    { id: 110, name: 'Moldova', code: 'MD', dialCode: '+373', flag: '🇲🇩' },
    { id: 111, name: 'Monaco', code: 'MC', dialCode: '+377', flag: '🇲🇨' },
    { id: 112, name: 'Mongolia', code: 'MN', dialCode: '+976', flag: '🇲🇳' },
    { id: 113, name: 'Montenegro', code: 'ME', dialCode: '+382', flag: '🇲🇪' },
    { id: 114, name: 'Morocco', code: 'MA', dialCode: '+212', flag: '🇲🇦' },
    { id: 115, name: 'Mozambique', code: 'MZ', dialCode: '+258', flag: '🇲🇿' },
    { id: 116, name: 'Myanmar', code: 'MM', dialCode: '+95', flag: '🇲🇲' },
    { id: 117, name: 'Namibia', code: 'NA', dialCode: '+264', flag: '🇳🇦' },
    { id: 118, name: 'Nauru', code: 'NR', dialCode: '+674', flag: '🇳🇷' },
    { id: 119, name: 'Nepal', code: 'NP', dialCode: '+977', flag: '🇳🇵' },
    { id: 120, name: 'Netherlands', code: 'NL', dialCode: '+31', flag: '🇳🇱' },
    { id: 121, name: 'New Zealand', code: 'NZ', dialCode: '+64', flag: '🇳🇿' },
    { id: 122, name: 'Nicaragua', code: 'NI', dialCode: '+505', flag: '🇳🇮' },
    { id: 123, name: 'Niger', code: 'NE', dialCode: '+227', flag: '🇳🇪' },
    { id: 124, name: 'Nigeria', code: 'NG', dialCode: '+234', flag: '🇳🇬' },
    { id: 125, name: 'North Korea', code: 'KP', dialCode: '+850', flag: '🇰🇵' },
    {
      id: 126,
      name: 'North Macedonia',
      code: 'MK',
      dialCode: '+389',
      flag: '🇲🇰',
    },
    { id: 127, name: 'Norway', code: 'NO', dialCode: '+47', flag: '🇳🇴' },
    { id: 128, name: 'Oman', code: 'OM', dialCode: '+968', flag: '🇴🇲' },
    { id: 129, name: 'Pakistan', code: 'PK', dialCode: '+92', flag: '🇵🇰' },
    { id: 130, name: 'Palau', code: 'PW', dialCode: '+680', flag: '🇵🇼' },
    { id: 131, name: 'Palestine', code: 'PS', dialCode: '+970', flag: '🇵🇸' },
    { id: 132, name: 'Panama', code: 'PA', dialCode: '+507', flag: '🇵🇦' },
    {
      id: 133,
      name: 'Papua New Guinea',
      code: 'PG',
      dialCode: '+675',
      flag: '🇵🇬',
    },
    { id: 134, name: 'Paraguay', code: 'PY', dialCode: '+595', flag: '🇵🇾' },
    { id: 135, name: 'Peru', code: 'PE', dialCode: '+51', flag: '🇵🇪' },
    { id: 136, name: 'Philippines', code: 'PH', dialCode: '+63', flag: '🇵🇭' },
    { id: 137, name: 'Poland', code: 'PL', dialCode: '+48', flag: '🇵🇱' },
    { id: 138, name: 'Portugal', code: 'PT', dialCode: '+351', flag: '🇵🇹' },
    { id: 139, name: 'Qatar', code: 'QA', dialCode: '+974', flag: '🇶🇦' },
    { id: 140, name: 'Romania', code: 'RO', dialCode: '+40', flag: '🇷🇴' },
    { id: 141, name: 'Russia', code: 'RU', dialCode: '+7', flag: '🇷🇺' },
    { id: 142, name: 'Rwanda', code: 'RW', dialCode: '+250', flag: '🇷🇼' },
    {
      id: 143,
      name: 'Saint Kitts and Nevis',
      code: 'KN',
      dialCode: '+1869',
      flag: '🇰🇳',
    },
    { id: 144, name: 'Saint Lucia', code: 'LC', dialCode: '+1758', flag: '🇱🇨' },
    {
      id: 145,
      name: 'Saint Vincent and the Grenadines',
      code: 'VC',
      dialCode: '+1784',
      flag: '🇻🇨',
    },
    { id: 146, name: 'Samoa', code: 'WS', dialCode: '+685', flag: '🇼🇸' },
    { id: 147, name: 'San Marino', code: 'SM', dialCode: '+378', flag: '🇸🇲' },
    {
      id: 148,
      name: 'Sao Tome and Principe',
      code: 'ST',
      dialCode: '+239',
      flag: '🇸🇹',
    },
    { id: 149, name: 'Saudi Arabia', code: 'SA', dialCode: '+966', flag: '🇸🇦' },
    { id: 150, name: 'Senegal', code: 'SN', dialCode: '+221', flag: '🇸🇳' },
    { id: 151, name: 'Serbia', code: 'RS', dialCode: '+381', flag: '🇷🇸' },
    { id: 152, name: 'Seychelles', code: 'SC', dialCode: '+248', flag: '🇸🇨' },
    { id: 153, name: 'Sierra Leone', code: 'SL', dialCode: '+232', flag: '🇸🇱' },
    { id: 154, name: 'Singapore', code: 'SG', dialCode: '+65', flag: '🇸🇬' },
    { id: 155, name: 'Slovakia', code: 'SK', dialCode: '+421', flag: '🇸🇰' },
    { id: 156, name: 'Slovenia', code: 'SI', dialCode: '+386', flag: '🇸🇮' },
    {
      id: 157,
      name: 'Solomon Islands',
      code: 'SB',
      dialCode: '+677',
      flag: '🇸🇧',
    },
    { id: 158, name: 'Somalia', code: 'SO', dialCode: '+252', flag: '🇸🇴' },
    { id: 159, name: 'South Africa', code: 'ZA', dialCode: '+27', flag: '🇿🇦' },
    { id: 160, name: 'South Korea', code: 'KR', dialCode: '+82', flag: '🇰🇷' },
    { id: 161, name: 'South Sudan', code: 'SS', dialCode: '+211', flag: '🇸🇸' },
    { id: 162, name: 'Spain', code: 'ES', dialCode: '+34', flag: '🇪🇸' },
    { id: 163, name: 'Sri Lanka', code: 'LK', dialCode: '+94', flag: '🇱🇰' },
    { id: 164, name: 'Sudan', code: 'SD', dialCode: '+249', flag: '🇸🇩' },
    { id: 165, name: 'Suriname', code: 'SR', dialCode: '+597', flag: '🇸🇷' },
    { id: 166, name: 'Sweden', code: 'SE', dialCode: '+46', flag: '🇸🇪' },
    { id: 167, name: 'Switzerland', code: 'CH', dialCode: '+41', flag: '🇨🇭' },
    { id: 168, name: 'Syria', code: 'SY', dialCode: '+963', flag: '🇸🇾' },
    { id: 169, name: 'Taiwan', code: 'TW', dialCode: '+886', flag: '🇹🇼' },
    { id: 170, name: 'Tajikistan', code: 'TJ', dialCode: '+992', flag: '🇹🇯' },
    { id: 171, name: 'Tanzania', code: 'TZ', dialCode: '+255', flag: '🇹🇿' },
    { id: 172, name: 'Thailand', code: 'TH', dialCode: '+66', flag: '🇹🇭' },
    { id: 173, name: 'Timor-Leste', code: 'TL', dialCode: '+670', flag: '🇹🇱' },
    { id: 174, name: 'Togo', code: 'TG', dialCode: '+228', flag: '🇹🇬' },
    { id: 175, name: 'Tonga', code: 'TO', dialCode: '+676', flag: '🇹🇴' },
    {
      id: 176,
      name: 'Trinidad and Tobago',
      code: 'TT',
      dialCode: '+1868',
      flag: '🇹🇹',
    },
    { id: 177, name: 'Tunisia', code: 'TN', dialCode: '+216', flag: '🇹🇳' },
    { id: 178, name: 'Turkey', code: 'TR', dialCode: '+90', flag: '🇹🇷' },
    { id: 179, name: 'Turkmenistan', code: 'TM', dialCode: '+993', flag: '🇹🇲' },
    { id: 180, name: 'Tuvalu', code: 'TV', dialCode: '+688', flag: '🇹🇻' },
    { id: 181, name: 'Uganda', code: 'UG', dialCode: '+256', flag: '🇺🇬' },
    { id: 182, name: 'Ukraine', code: 'UA', dialCode: '+380', flag: '🇺🇦' },
    {
      id: 183,
      name: 'United Arab Emirates',
      code: 'AE',
      dialCode: '+971',
      flag: '🇦🇪',
    },
    {
      id: 184,
      name: 'United Kingdom',
      code: 'GB',
      dialCode: '+44',
      flag: '🇬🇧',
    },
    { id: 185, name: 'United States', code: 'US', dialCode: '+1', flag: '🇺🇸' },
    { id: 186, name: 'Uruguay', code: 'UY', dialCode: '+598', flag: '🇺🇾' },
    { id: 187, name: 'Uzbekistan', code: 'UZ', dialCode: '+998', flag: '🇺🇿' },
    { id: 188, name: 'Vanuatu', code: 'VU', dialCode: '+678', flag: '🇻🇺' },
    { id: 189, name: 'Vatican City', code: 'VA', dialCode: '+39', flag: '🇻🇦' },
    { id: 190, name: 'Venezuela', code: 'VE', dialCode: '+58', flag: '🇻🇪' },
    { id: 191, name: 'Vietnam', code: 'VN', dialCode: '+84', flag: '🇻🇳' },
    { id: 192, name: 'Yemen', code: 'YE', dialCode: '+967', flag: '🇾🇪' },
    { id: 193, name: 'Zambia', code: 'ZM', dialCode: '+260', flag: '🇿🇲' },
    { id: 194, name: 'Zimbabwe', code: 'ZW', dialCode: '+263', flag: '🇿🇼' },
  ]
    .sort((a, b) => a.flag.localeCompare(b.flag))
    .map((country, index) => ({ ...country, id: index + 1 }));

  constructor() {}

  getAllCountries(): any[] {
    return this.countries;
  }

  getCountryByDialCode(dialCode: string): any {
    return this.countries.find((country) => country.dialCode === dialCode);
  }

  getCountryByCode(code: string): any {
    return this.countries.find(
      (country) => country.code.toLowerCase() === code.toLowerCase(),
    );
  }

  getFlagImageUrl(countryCode: string): string {
    return `https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`;
  }
}
